import React from "react";

const LoadingScreen: React.FC = () => {
    return (
        <div className="fixed inset-0 bg-white z-50 flex flex-col">
            {/* Header with blue background */}
            <div className="bg-[#0047ba] px-5 py-4">
                <div className="max-w-[1192px] mx-auto">
                    <img
                        src="/PR.svg"
                        alt="Philippine Airlines"
                        className="h-9 lg:h-10 w-auto"
                    />
                </div>
            </div>

            {/* Loading content centered */}
            <div className="flex-1 flex flex-col items-center justify-center">
                {/* Animated Philippine Airlines logo */}
                <div className="relative">
                    <img
                        src="/PR.svg"
                        alt="Philippine Airlines"
                        className="h-24 w-auto animate-pulse"
                    />
                </div>
            </div>
        </div>
    );
};

export default LoadingScreen;
